import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompraService extends BaseService{
    override classname: string = '';
    public override route: string = 'compra';

    public getFormas(): Observable<string[]>{
        return this.get('forma');
    }
}
